import React from "react";
import { Box, Typography } from "@mui/material";
import { InsertDriveFile } from "@mui/icons-material";
import { grey } from "@mui/material/colors";

interface AttachmentsEmptyStateProps {
  message: string;
}

const AttachmentsEmptyState: React.FC<AttachmentsEmptyStateProps> = ({ message }) => (
  <Box
    display="flex"
    flexDirection="column"
    alignItems="center"
    justifyContent="center"
    py={4}
    px={2}
  >
    <InsertDriveFile
      sx={{ fontSize: 56, color: grey[400], mb: 1 }}
      aria-hidden
    />
    <Typography variant="body2" color="text.secondary" textAlign="center">
      {message}
    </Typography>
  </Box>
);

export default AttachmentsEmptyState;
